// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const seviper: PokeData = {
  "id": 336,
  "name": "seviper",
  "height": 27,
  "weight": 525,
  "base_experience": 160,
  "types": [
    PokeType.POISON
  ],
  "api_moves": [
    "swords-dance",
    "wrap",
    "bite",
    "screech",
    "haze",
    "lick",
    "glare",
    "sludge-bomb",
    "swagger",
    "crunch",
    "poison-fang",
    "poison-tail",
    "feint",
    "wring-out",
    "gastro-acid",
    "poison-jab",
    "night-slash",
    "venoshock",
    "coil",
    "belch",
    "venom-drench"
  ],
  "moves": [
    "bite",
    "lick",
    "sludge-bomb",
    "crunch",
    "poison-fang",
    "poison-jab",
    "night-slash",
    "venom-drench",
    "poison-powder",
    "acid",
    "poison-gas",
    "stun-spore",
    "acid-rain"
  ],
  "evolution_chain": {
    "id": 170,
    "item": null,
    "species": [
      {
        "name": "seviper",
        "order": 364,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 115,
    "speed": 112,
    "ability_power": 173
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
